import React from 'react'
import { withTranslation } from 'themes/modules/I18n'
import Layout from 'themes/layouts/Login'
import { Result, Button } from 'antd';
import useBaseHook from 'themes/hooks/BaseHooks'


const Error = ({ statusCode }) => {
  const { t, router } = useBaseHook()

  if (statusCode == 404) {
    return (
      <Result
        status="404"
        title={t("pages:errors.404.title")}
        subTitle={<div>{t("pages:errors.404.description")}<br /></div>}
        extra={<Button type="primary" onClick={() => router.back()}>{t("back")}</Button>}
      />
    )
  }

  return <Result
    status="default"
    title={t("pages:errors.default.title")}
    subTitle={<div>{t("pages:errors.default.description")}<br /></div>}
    extra={<Button type="primary" onClick={() => router.back()}>{t("back")}</Button>}
  />
}

Error.getInitialProps = async ({ res, err }) => {
  let statusCode = null
  if (res) {
    ({ statusCode } = res)
  } else if (err) {
    ({ statusCode } = err)
  }
  return {
    namespacesRequired: ['common'],
    statusCode,
  }
}

Error.defaultProps = {
  statusCode: null,
}


export default withTranslation('common')(Error)